import { Carousel, Button, Typography } from 'antd';

const HeroCarousel = ({ slides = [] }) => {
    if (!slides?.length) return null;

    return (
        <div className="hero-carousel w-full overflow-hidden relative">
            <Carousel autoplay effect="fade" speed={800} arrows>
                {slides?.map((slide, idx) => (
                    <div key={idx} className="carousel-slide h-30rem relative w-full overflow-hidden">
                        <div className="background-image absolute bg-cover bg-no-repeat bg-center" style={{ backgroundImage: `url(${slide.image})` }} />
                        <div className="gradient-overlay overflow-hidden absolute z-2 flex align-items-center justify-content-flex-start px-8">
                            <div className="text-content">
                                <Typography.Title level={1} className="text-white font-bold mb-2">{slide.title}</Typography.Title>
                                <Typography.Paragraph type='secondary' className="text-white mb-4 max-w-25rem">{slide.description}</Typography.Paragraph>
                                <Button type="primary" size="large" className='cta-btn' href={slide?.button?.link || '#'}>
                                    {slide?.button?.text || 'Find out more'}
                                </Button>
                            </div>
                        </div>
                    </div>
                ))}
            </Carousel>
        </div>
    );
};

export default HeroCarousel;
